'use client'

import React from 'react'
import { useRouter } from 'next/navigation'
import { X } from 'lucide-react'
import { CartPlus } from 'solar-icons'
import { useCheckout, useSearchParams, useSelectedCustomer } from '@/lib/hooks'
import { cn } from '@/lib/utils'

import { Button } from '@/components/ui'
import { CancelCart } from '@/components/molecules'

export const CartHeaderActions = () => {
  const router = useRouter()
  const { setIsCheckout, fully_paid } = useCheckout()
  const { customer, setAsGuestCustomer } = useSelectedCustomer()
  const { isCheckout, cartId, orderId } = useSearchParams()

  return (
    <div className="hidden w-full flex-grow gap-2 lg:flex lg:h-10 lg:w-auto lg:items-center lg:justify-end">
      {!fully_paid && !orderId && (
        <CancelCart
          cartId={cartId as string}
          callback={() => router.push('/')}
        />
      )}

      {isCheckout && (
        <>
          {!fully_paid && !orderId && (
            <Button
              variant="outline"
              size="sm"
              className="h-10 gap-2"
              onClick={() => setIsCheckout(false)}
            >
              <CartPlus strokeWidth={1.2} className="size-5" />
              <span>Select Products</span>
            </Button>
          )}

          {customer && (
            <div
              className={cn(
                'flex h-10 shrink-0 items-center gap-2 rounded-[8px] px-3 py-1 text-right',
              )}
            >
              <div className="flex flex-col">
                <span className="text-sm font-medium">{customer?.name}</span>
                <span className="text-xs font-medium text-gray-500">
                  {customer?.phone}
                </span>
              </div>

              <Button
                variant="secondary"
                className="size-10 p-0"
                onClick={setAsGuestCustomer}
              >
                <X className="size-4" strokeWidth={1.5} />
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  )
}
